import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NameValueDto, SettingScopes, TimingServiceProxy } from '@shared/service-proxies/service-proxies';


@Component({
    selector: 'timezone-combo',
    template: `
    <select class="form-control" [formControl]="selectedTimeZone">
      @for (timeZone of timeZones; track timeZone) {
        <option [value]="timeZone.value">{{timeZone.name}}</option>
      }
    </select>`,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimeZoneComboComponent),
            multi: true,
        }],
    imports: [FormsModule, ReactiveFormsModule]
})
export class TimeZoneComboComponent extends AppComponentBase implements OnInit, ControlValueAccessor {

    @Input() defaultTimezoneScope: SettingScopes;

    timeZones: NameValueDto[] = [];
    selectedTimeZone = new FormControl('');

    onTouched: any = () => { };

    constructor(
        private _timingService: TimingServiceProxy,
        injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        let self = this;
        self._timingService.getTimezones(self.defaultTimezoneScope).subscribe(result => {
            self.timeZones = result.items;
        });
    }

    writeValue(obj: any): void {
        if (this.selectedTimeZone) {
            this.selectedTimeZone.setValue(obj);
        }
    }

    registerOnChange(fn: any): void {
        this.selectedTimeZone.valueChanges.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) {
            this.selectedTimeZone.disable();
        } else {
            this.selectedTimeZone.enable();
        }
    }
}
